module.exports = __webpack_public_path__ + "img/1474981175.ae93dfb5.jpg";